export default __webpack_public_path__ + "static/media/hero-bg-02.d37d9f31.jpg";